import { STATUS_CODE } from '@vuejs/helpers/_constants'
import $ from 'jquery'

import { showNotification } from './notificationHelper'

export default function initConfirmationDialog(): void {
	$('#create-agency_mgr, #create-franchisor_mgr').on('click', function (event) {
		let $form: JQuery

		if (event.target.id === 'create-agency_mgr') {
			$form = $('#new_administrator')
		} else {
			$form = $('#new_user')
		}

		if (($form[0] as HTMLFormElement).checkValidity() === false) {
			return
		}

		event.preventDefault()

		// Send verification request before adding a new user/role
		$.ajax({
			data: $form.serializeArray(),
			headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') as string },
			method: 'POST',
			url: $form.data('verification-url') as string,
		})
			.done(function (data: { message: string }, textStatus: string, xhr: JQuery.jqXHR) {
				switch (xhr.status) {
					case STATUS_CODE.OK:
						if (confirm(data.message) === true) {
							createNewUserRole($form)
						}
						break

					case STATUS_CODE.NO_CONTENT:
						createNewUserRole($form)
						break

					default:
						showNotification('An error occurred', 'error')
				}
			})
			.fail(function (error: JQuery.jqXHR) {
				const message = error.responseJSON?.message || 'An error occurred'

				showNotification(message, 'error')
			})
	})

	function createNewUserRole($form: JQuery): void {
		$.ajax({
			data: $form.serializeArray(),
			headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') as string },
			method: 'POST',
			url: $form.data('invite-url') as string,
		})
			.done(function () {
				// flash message is sent by rails controller
				window.location.href = $form.data('redirect-url') as string
			})
			.fail(function (error: JQuery.jqXHR) {
				const message = error.responseJSON?.message || 'An error occurred'

				showNotification(message, 'error')
			})
	}
}
